import moment from 'moment'
import Favorites from '../../views/dashboard/tracker/models/favorites'

const initialState = {
  showFeedback: false,
  feedback: 'Test',
  feedbackError: false,
  isLoading: false,
  selectedDay: moment().local().format('YYYY-MM-DD'),
  recentsData: { level: 0 },
}

export default function timelineReducer(state = initialState, action) {
  switch (action.type) {
    case 'TIMELINE_FORWARD': {
      const selectedDay = moment(state.selectedDay, 'YYYY-MM-DD').local().add(action.increment, 'days').format('YYYY-MM-DD')
      state = { ...state, selectedDay }
      break
    }
    case 'TIMELINE_BACKWARD': {
      const selectedDay = moment(state.selectedDay, 'YYYY-MM-DD').local().subtract(action.decrement, 'days').format('YYYY-MM-DD')
      state = { ...state, selectedDay }
      break
    }
    case 'TIMELINE_JUMP': {
      const selectedDay = action.jumpTo
      state = { ...state, selectedDay }
      break
    }
    case 'ADD_TIMELINE_ITEM': {
      const { date, item } = action
      const newTimeline = Object.assign({}, state.timeline)
      const newDateAdded = (new Date()).toISOString()
      let newRecentsData = Object.assign({}, state.recentsData)

      if(!newTimeline[date])
        newTimeline[date] = []

      newTimeline[date].push(item)

      if(state.recentsData.level === 2) {
        let found = false
        let newRecents = []
        state.recentsData.recents.forEach((oldItem) => {
          if(item.name === oldItem.name) {
            newRecents.push(Object.assign({}, oldItem, {count: oldItem.count + 1, dateAdded: newDateAdded}))
            found = true
          } else {
            newRecents.push(oldItem)
          }
        })
        if(!found) {
          newRecents.push(Object.assign({}, item, {count: 1, dateAdded: newDateAdded}))
        }
        newRecents.sort((a, b) => a.dateAdded < b.dateAdded ? 1 : (a.dateAdded > b.dateAdded ? -1 : 0))
        newRecentsData.recents = newRecents
      }

      state = { ...state, timeline: newTimeline, recentsData: newRecentsData }
      break
    }
    case 'EDIT_TIMELINE_ITEM':
      const newTimeline = Object.assign({}, state.timeline)
      for(let n = 0; n < newTimeline[action.date].length; n++) {
        if(action.editedItem.id) {
          if(newTimeline[action.date][n].id === action.editedItem.id) {
            newTimeline[action.date][n] = action.editedItem
          }
        } else {
          if(newTimeline[action.date][n].dateAdded === action.editedItem.dateAdded) {
            newTimeline[action.date][n] = action.editedItem
          }
        }
      }
      // newTimeline[action.date][action.index] = action.editedItem
      state = { ...state, timeline: newTimeline }
      break
    case 'REMOVE_TIMELINE_ITEM': {
      const { date, index } = action
      const newTimeline = Object.assign({}, state.timeline)

      newTimeline[date].splice(index, 1)
      state = { ...state, timeline: newTimeline }
      break
    }
    case 'ADD_FAVORITE': {
      const { newFavoriteItem } = action
      const favorites = new Favorites(state.favorites)
      favorites.addFavorite(newFavoriteItem.toObject())
      const newFavorites = favorites.toObject()
      state = { ...state, favorites: newFavorites }
      break
    }
    case 'EDIT_FAVORITE': {
      const { editedFavorite } = action
      const favorites = new Favorites(state.favorites)
      favorites.editFavorite(editedFavorite)
      const newFavorites = favorites.toObject()
      state = { ...state, favorites: newFavorites }
      break
    }
    case 'EDIT_FAVORITE_NEW_NAME': {
      const { oldName, editedFavorite } = action
      const favorites = new Favorites(state.favorites)
      favorites.removeFavorite(oldName, editedFavorite.dateCreated)
      favorites.addFavorite(editedFavorite.toObject())
      const newFavorites = favorites.toObject()
      state = { ...state, favorites: newFavorites }
      break
    }
    case 'REMOVE_FAVORITE': {
      const { favoriteToBeRemoved } = action
      const favorites = new Favorites(state.favorites)
      favorites.removeFavorite(favoriteToBeRemoved.name, favoriteToBeRemoved.dateCreated)
      const newFavorites = favorites.toObject()
      state = { ...state, favorites: newFavorites }
      break
    }
    case 'COPY_TIMELINE_ITEM': {
      const { datesTo, item, id_list } = action
      let newTimeline = Object.assign({}, state.timeline)

      datesTo.forEach((dateTo) => {
        if(!newTimeline[dateTo])
          newTimeline[dateTo] = []

        let newItem = Object.assign({}, item)
        newItem['id'] = id_list[dateTo]
        newTimeline[dateTo].push(newItem)
      })
      state = { ...state, timeline: { ...newTimeline } }
      break
    }
    case 'COPY_TIMELINE_MEAL': {
      const { fromDate, datesTo, meal, category, newDateAdded, id_list } = action
      let newTimeline = Object.assign({}, state.timeline)
      let items = []

      state.timeline[fromDate].forEach((item) => {
        if(item.category === meal)
          items.push(Object.assign({}, item, {category: category}))
      })

      datesTo.forEach((dateTo) => {
        if(!newTimeline[dateTo])
          newTimeline[dateTo] = []

        items.forEach((item, index) => {
          item.id = id_list[dateTo][item.id]
          item.dateAdded = new Date(newDateAdded)
          // Hack to avoid duplicate dateAdded if copying multiples of same food
          item.dateAdded.setSeconds(item.dateAdded.getSeconds() + index + 1)
          item.dateAdded = item.dateAdded.toISOString()

          newTimeline[dateTo].push(Object.assign({}, item))
        })
      })

      state = { ...state, timeline: { ...newTimeline } }
      break
    }
    case 'GET_TRACKER_DATA': {
      state = { ...state, isLoading: true}
      break
    }
    case 'GET_TRACKER_DATA_FULFILLED': {
      if(action.payload.timeline) {
        state = { ...state, timeline: { ...state.timeline,  ...action.payload.timeline }, favorites: action.payload.favorites, isLoading: false }
      }
      break
    }
    case 'GET_RECENTS': {
      state = { ...state, recentsData: { level: 1 } }
      break
    }
    case 'GET_RECENTS_FULFILLED': {
      state = { ...state, recentsData: { level: 2,  recents: action.payload.recents } }
      break
    }
    case 'OPEN_TRACKER_FEEDBACK': {
      state = {...state, ...action.payload};
      break
    }
    case 'CLOSE_TRACKER_FEEDBACK': {
      state = {...state, ...action.payload};
      break
    }
    case 'LOGOUT': {
      state = initialState;
      break;
    }
    case 'CLEAR_TRACKER':
      state = initialState;
      break
    default:
      break
  }
  return state
}
